import React from 'react';
import Header from './Header';
import SeasonSelector from '../seasons/SeasonSelector';

/**
 * HeaderWithSeasonSelector component that combines the Header with a SeasonSelector
 * 
 * @param {Object} props - Component props
 * @param {string} props.title - Main title to display
 * @param {string} [props.subtitle] - Optional subtitle or section description
 * @param {boolean} [props.showBack=false] - Whether to show back button
 * @param {Function} [props.onBack] - Callback when back button is pressed
 * @param {Array} [props.actions] - Array of action button configs
 * @param {string} [props.bgColor='bg-blue-600'] - Background color class
 * @param {boolean} [props.elevated=true] - Whether to add shadow for elevation
 */
const HeaderWithSeasonSelector = ({ 
  title,
  subtitle,
  showBack = false,
  onBack,
  actions = [],
  bgColor = 'bg-blue-600',
  elevated = true
}) => {
  return (
    <div>
      <Header
        title={title}
        subtitle={subtitle}
        showBack={showBack}
        onBack={onBack}
        actions={actions}
        bgColor={bgColor}
        elevated={elevated}
      />
      <div className="px-4 py-2 bg-white dark:bg-dark-200 border-b border-gray-200 dark:border-dark-400 shadow-sm">
        <SeasonSelector />
      </div>
    </div>
  );
};

export default HeaderWithSeasonSelector;
